export const constants = {
  BACKENDURL: process.env.VUE_APP_BACKEND_URL,
  SPOTIFY_CLIENT_ID: "f1304b04bfa1419bbe000e954af5b722"
};
